import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { FaSpinner } from "react-icons/fa";
import { db } from "../Configuration/firebase";

// Gate for the Safety and Event features: both require a verified phone number
// (Safety texts your contacts; Events are gated the same way so every sharing
// action is tied to a real, reachable number). Existing users who signed up
// before phones were collected get routed to /verify-phone first, then bounced
// back to wherever they were headed.
const RequirePhone = ({ children }) => {
  const location = useLocation();
  const [status, setStatus] = useState("checking"); // checking | ok | needs-phone | signed-out

  useEffect(() => {
    const unsub = onAuthStateChanged(getAuth(), async (user) => {
      if (!user) {
        setStatus("signed-out");
        return;
      }
      try {
        const snap = await getDoc(doc(db, "users", user.uid));
        const verified = snap.exists() && snap.data().phoneVerified === true;
        setStatus(verified ? "ok" : "needs-phone");
      } catch (err) {
        console.error("Error checking phone verification:", err);
        // Fail closed - send them through verification rather than into a
        // feature that will misbehave without a phone on file.
        setStatus("needs-phone");
      }
    });
    return () => unsub();
  }, []);

  if (status === "checking") {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          marginTop: "30vh",
        }}
      >
        <FaSpinner size={40} className="spin" />
      </div>
    );
  }

  if (status === "signed-out") {
    return <Navigate to="/login" replace />;
  }

  if (status === "needs-phone") {
    return <Navigate to="/verify-phone" state={{ from: location }} replace />;
  }

  return children;
};

export default RequirePhone;
